import { useToggleRedux } from '@deltasierra/react-hooks';
import DateRangeTuple from '../date-range-tuple.type';

export function useToggledSetDate(
    value: DateRangeTuple,
    onChange?: (value: DateRangeTuple) => void,
): [(date?: Date) => void, boolean] {
    const [selected, selectedTo] = value;
    const [isSelectingTo, toggle] = useToggleRedux(!!selected && !selectedTo);
    function setDate(newDate?: Date) {
        if (isSelectingTo) {
            if (!!newDate && !!selected && newDate < selected) {
                onChange?.([newDate, undefined]);
            } else {
                onChange?.([selected, newDate]);
                toggle(false);
            }
        } else {
            if (!!newDate && !!selectedTo && newDate > selectedTo) {
                onChange?.([newDate, undefined]);
            } else {
                onChange?.([newDate, selectedTo]);
            }
            toggle();
        }
    }
    return [setDate, isSelectingTo];
}
